if (!window.Eurus.loadedScript.has('product-wishlist-button.js')) {
  window.Eurus.loadedScript.add('product-wishlist-button.js');

  const productWishlistContainerSelector = '.product-page .x-block-buy-buttons[data-product-id]';
  const productWishlistButtonSelector = [
    '.atw-button',
    '.swym-button-content > button.swym-icon-text',
    '.swym-button-content > button',
    '.swym-button-content > [role="button"]'
  ].join(',');
  const pendingWishlistStateDuration = 5000;
  const pendingWishlistStates = new Map();

  function getSwymApi(callback) {
    if (window._swat) {
      callback(window._swat);
      return;
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push((swymApi) => callback(swymApi || window._swat));
  }

  function fetchWishlistItems(swymApi, callback) {
    if (!swymApi) {
      callback([]);
      return;
    }

    if (typeof swymApi.fetch === 'function') {
      swymApi.fetch((wishlistItems) => callback(Array.isArray(wishlistItems) ? wishlistItems : []));
      return;
    }

    if (typeof swymApi.fetchWrtEventTypeET === 'function') {
      swymApi.fetchWrtEventTypeET((wishlistItems) => callback(Array.isArray(wishlistItems) ? wishlistItems : []), 4);
      return;
    }

    callback([]);
  }

  function getProductWishlistItem(container) {
    const variantInput = container.querySelector('input[name="id"]');

    return {
      epi: Number(variantInput?.value || container.dataset.variantId),
      empi: Number(container.dataset.productId),
      du: container.dataset.productUrl
    };
  }

  function isMatchingWishlistItem(wishlistItem, currentItem) {
    if (!wishlistItem || !currentItem) return false;

    const wishlistVariantId = Number(wishlistItem.epi || wishlistItem.variant_id || wishlistItem.variantId);
    const wishlistProductId = Number(wishlistItem.empi || wishlistItem.product_id || wishlistItem.productId);

    if (wishlistVariantId && currentItem.epi) {
      return wishlistVariantId === currentItem.epi;
    }

    return wishlistProductId && currentItem.empi && wishlistProductId === currentItem.empi;
  }

  function getWishlistItemKey(currentItem) {
    if (!currentItem) return '';

    return [currentItem.empi || '', currentItem.epi || ''].join(':');
  }

  function getPendingWishlistState(currentItem) {
    const pendingState = pendingWishlistStates.get(getWishlistItemKey(currentItem));

    if (!pendingState) return null;

    if (pendingState.expiresAt <= Date.now()) {
      pendingWishlistStates.delete(getWishlistItemKey(currentItem));
      return null;
    }

    return pendingState.isAdded;
  }

  function setPendingWishlistState(currentItem, isAdded) {
    pendingWishlistStates.set(getWishlistItemKey(currentItem), {
      isAdded,
      expiresAt: Date.now() + pendingWishlistStateDuration
    });
  }

  function clearPendingWishlistState(currentItem) {
    pendingWishlistStates.delete(getWishlistItemKey(currentItem));
  }

  function callProductWishlistAction(container, wishlistItem, isAdded) {
    const nextWishlistState = !isAdded;

    setPendingWishlistState(wishlistItem, nextWishlistState);
    setProductWishlistContainerState(container, nextWishlistState);

    getSwymApi((swymApi) => {
      const swymWishlistAction = isAdded
        ? swymApi && (swymApi.removeFromWishList || swymApi.removeFromWishlist)
        : swymApi && (swymApi.addToWishList || swymApi.addToWishlist);

      if (typeof swymWishlistAction !== 'function') {
        clearPendingWishlistState(wishlistItem);
        syncProductWishlistContainer(container);
        return;
      }

      swymWishlistAction.call(swymApi, wishlistItem, () => {
        clearPendingWishlistState(wishlistItem);
        setProductWishlistContainerState(container, nextWishlistState);
        scheduleProductWishlistSync(250);
      }, () => {
        clearPendingWishlistState(wishlistItem);
        setProductWishlistContainerState(container, isAdded);
      });
    });
  }

  function setProductWishlistContainerState(container, isAdded) {
    const stateElements = [
      container,
      ...container.querySelectorAll(productWishlistButtonSelector),
      ...container.querySelectorAll('.swym-button-content, .swym-atw-btn-wrapper')
    ];

    stateElements.forEach((element) => {
      element.classList.toggle('is-added', isAdded);
      element.classList.toggle('swym-added', isAdded);
    });

    container.querySelectorAll(productWishlistButtonSelector).forEach((button) => {
      button.setAttribute('aria-pressed', isAdded.toString());
      button.setAttribute('data-swaction', isAdded ? 'removeFromWishlist' : 'addToWishlist');
    });
  }

  function syncProductWishlistContainer(container) {
    getSwymApi((swymApi) => {
      const currentItem = getProductWishlistItem(container);
      const pendingWishlistState = getPendingWishlistState(currentItem);

      if (pendingWishlistState !== null) {
        setProductWishlistContainerState(container, pendingWishlistState);
        return;
      }

      fetchWishlistItems(swymApi, (wishlistItems) => {
        const isAdded = wishlistItems.some((wishlistItem) => isMatchingWishlistItem(wishlistItem, currentItem));
        clearPendingWishlistState(currentItem);
        setProductWishlistContainerState(container, isAdded);
      });
    });
  }

  function syncProductWishlistButtons() {
    document.querySelectorAll(productWishlistContainerSelector).forEach(syncProductWishlistContainer);
  }

  function scheduleProductWishlistSync(initialDelay = 250) {
    window.setTimeout(syncProductWishlistButtons, initialDelay);
    window.setTimeout(syncProductWishlistButtons, Math.max(initialDelay + 650, 900));
    window.setTimeout(syncProductWishlistButtons, Math.max(initialDelay + 1550, 1800));
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(productWishlistButtonSelector);
    const container = button?.closest(productWishlistContainerSelector);
    if (!button || !container) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const currentItem = getProductWishlistItem(container);
    const pendingWishlistState = getPendingWishlistState(currentItem);
    const isAdded = pendingWishlistState ?? (
      button.classList.contains('is-added')
      || button.classList.contains('swym-added')
      || button.getAttribute('aria-pressed') === 'true'
      || container.classList.contains('is-added')
      || container.classList.contains('swym-added')
    );

    callProductWishlistAction(container, currentItem, isAdded);
  }, true);

  document.addEventListener('eurus:variant:change', () => scheduleProductWishlistSync(100));
  document.addEventListener('DOMContentLoaded', () => scheduleProductWishlistSync(100));
  window.addEventListener('load', scheduleProductWishlistSync);

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(scheduleProductWishlistSync);
}
